import React, {useState, Suspense} from 'react';
import { Link , useLocation, useHistory } from 'react-router-dom';
// import LinkPreview from '@ashwamegh/react-link-preview'
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import CommonUtil from 'utils/CommonUtil';
import UISunEditor from "components/wysiwygeditor/UISunEditor";
import UI from "components/UI";
import UIDatePicker from "components/datepicker";
import DateUtil from "utils/DateUtil";
import TbComFile from "domain/main/com/file/TbComFile";
import UIUtils from "utils/UIUtils";
import PageLoading from "../../../../components/loading";
import ModalPopup from "../../../../components/modal";
import useToggleState from "../../../../components/hooks/useToggleState";

function ContentsContainer() {
    const history = useHistory();
    const location = useLocation();
    const [popDetail, setPopDetail] = useState<any>([]);
    const [popNo, setPopNo] = useState('');
    const [popTitle, setPopTitle] = useState('');
    const [notiTpCd, setNotiTpCd] = useState('P');
    const [stDate, setStDate] = useState(new Date());
    const [enDate, setEnDate] = useState(new Date());
    const [popHeight, setPopHeight] = useState(0);
    const [popWidth, setPopWidth] = useState(0);
    const [popTopPos, setPopTopPos] = useState(0);
    const [popLeftPos, setPopLeftPos] = useState(0);
    const [linkUrl, setLinkUrl] = useState('');
    const [imgPath, setImgPath] = useState('');
    const [popStsCd, setPopStsCd] = useState('Y');
    const [popSelect, setPopSelect] = useState('1');    // 첨부방식 선택
    const [imgPreview, setImgPreview] = useState('');

    const [popFileValue] = useState(new TbComFile());
    const [fileInfoList, setFileInfoList] = React.useState<any[]>([]);

    // 폼체크 여부
    const [formCheck,setFormCheck] = useState(false);

    const [modal5312IsOpen, setModal5312IsOpen] = useState(false);

    //초기 데이터 설정
    let data = {};
    let param = {};

    const handleSelect = (e) => {
       if(e.target.name === 'popSelect'){
            setPopSelect(e.target.value);
       } else if(e.target.name === 'popStsCd'){
           setPopStsCd(e.target.value);
       }
    };

    //파일업로드
    const [uploadId, setUploadId] = React.useState("");

    //파일업로드
    const onCreationComplete = function (uploadID: string) {
        setUploadId(uploadID);
    }

    //파일업로드 완료
    const onUploadComplete = () => {
        const dataArray = window["RAONKUPLOAD"].GetListInfo('array', uploadId);
        const arrayNew = dataArray.newFile;
        const arrayDel = dataArray.deleteFile;
        console.log(JSON.stringify(arrayNew));

        let fileInfos : {
            FILE_DETAIL_ID:string;
            ORGINL_FILE_NM:string;
            STRE_FILE_NM:string;
            FILE_SIZE:number;
            STRE_PATH:string;
            FILE_EXTSN:string;
            FILE_GB:string;
            FILE_STATUS:string;
        }[] = [];

        let fileInfo : {
            FILE_DETAIL_ID:string;
            ORGINL_FILE_NM:string;
            STRE_FILE_NM:string;
            FILE_SIZE:number;
            STRE_PATH:string;
            FILE_EXTSN:string;
            FILE_GB:string;
            FILE_STATUS:string;
        };

        //파일등록 정보
        arrayNew?.map((item, index) => {
            if(item.status =="complete"){
                fileInfo = {
                    FILE_DETAIL_ID:item.uniqKey,
                    ORGINL_FILE_NM:item.originalName,
                    STRE_FILE_NM:item.uploadName,
                    FILE_SIZE:item.size,
                    STRE_PATH:"/" + item.uploadPath.split("/").reverse().slice(1, 3).reverse().join("/") ,
                    FILE_EXTSN:item.extension,
                    FILE_GB:"FILE",
                    FILE_STATUS:"ADD"
                }

                fileInfos.push(fileInfo);
            }

            console.log("fileInfos : "+JSON.stringify(fileInfos));
        })

        //파일등록 정보
        arrayDel?.forEach((item, index) => {
            fileInfo = {
                FILE_DETAIL_ID:item.uniqKey,
                ORGINL_FILE_NM:item.originalName,
                STRE_FILE_NM:item.uploadName,
                FILE_SIZE:item.size,
                STRE_PATH:"/" + item.uploadPath.split("/").reverse().slice(1, 3).reverse().join("/") ,
                FILE_EXTSN:item.extension,
                FILE_GB:"FILE",
                FILE_STATUS:"DEL"
            }

            fileInfos.push(fileInfo);

        })
        setFileInfoList(fileInfos);

    }

    const onFileUpload = () => {
		if(uploadId){
			window["RAONKUPLOAD"].Transfer(uploadId);
		}
	}

    // 팝업 파일 업로드
    async function popFormCheck() {

        // 필수값 체크
        if(popTitle == ''){
            UIUtils.alert("제목을 입력해주세요.").then();
            return;
        }

        if(popHeight <= 0){
            UIUtils.alert("팝업 높이를 입력해주세요.").then();
            return;
        }

        if(popWidth <= 0){
            UIUtils.alert("팝업 너비를 입력해주세요.").then();
            return;
        }

        if(popTopPos <= 0){
            UIUtils.alert("팝업 상단위치를 입력해주세요.").then();
            return;
        }

        if(popLeftPos <= 0){
            UIUtils.alert("팝업 좌측위치를 입력해주세요.").then();
            return;
        }

        if(popSelect == '2' && imgPath == ''){
            UIUtils.alert("이미지 URL을 입력해주세요.").then();
            return;
        }

        if(await UIUtils.confirm('저장하시겠습니까?')){

            setFormCheck(true);
            // 파일 업로드
            onFileUpload();
        }

    }

    // 팝업 저장
    async function popSave(sendParam:any){

        var regPopNo = await genPopKey();
        sendParam.POP_NO = regPopNo;

        const response:any = await CommonUtil.execute({
            url:"adm_5312.jct",
            data: sendParam
        }).then((response: any) => {
            regPopNo = response.POP_NO;
            UIUtils.alert("저장되었습니다.").then();
        }).catch((error) => {
            CommonUtil.showAxiosError(error);
            return;
        });

        // 완료 후 상세화면으로 이동
        let dataToSend = { POP_NO: regPopNo};
        history.push({
          pathname: './adm5311',
          state: { data : dataToSend }
        });

    };

    async function genPopKey() {

        const response:any = await CommonUtil.execute({
            url:"adm_5120_newIdGen.jct",
            data: {NOTI_TP_CD : notiTpCd}
        });

        return response.LST_GIV_NO;

    }

    // React.useEffect(() => {
    //     genPopKey();
    // }, [])

    // 파일 업로드 성공여부 체크
    React.useEffect(() => {
        if(fileInfoList && formCheck) {
            // 파일 업로드 성공
            let param ={
                POP_NO : popNo,
                NOTI_TP_CD: notiTpCd,
                POP_TITLE : popTitle,
                ST_DATE : DateUtil.toDateFormat(stDate, "YYYYMMDDHHmmss"),
                EN_DATE : DateUtil.toDateFormat(enDate, "YYYYMMDDHHmmss"),
                POP_HEIGHT : popHeight,
                POP_WIDTH : popWidth,
                POP_TOP_POS : popTopPos,
                POP_LEFT_POS : popLeftPos,
                LINK_URL : linkUrl,
                IMG_PATH : imgPath,
                POP_STS_CD : popStsCd,
                FILE_INFO_LIST:fileInfoList,
            }

            console.log("param : "+JSON.stringify(param));

            //내용 저장
            popSave(param);

        }
    }, [fileInfoList])

    // 목록 이동
    async function onClickList(event) {
        event.preventDefault();
        // 다른 페이지로 이동하면서 데이터 전달
        history.push({
          pathname: './adm5310',
        });

    };

    async function onClose() {
        setModal5312IsOpen(false);
    }

	return (
		<PageContainer>
			<LayoutAside />
			<div className="fww-con">
				<ul className="fww-brd">
					<li><Link to="/admin/">홈</Link></li>
					<li><Link to="#">관리자페이지</Link></li>
					<li><Link to="#">게시판관리</Link></li>
					<li><Link to="#">팝업관리</Link></li>
				</ul>
				<main className="fww-main">
					<h1 className="tx tx-hd2">팝업등록</h1>
					<form className="fo fo-col2" name="" action="" method="">
						<div className="inner">
							<div className="fo-item fo-m-1-3  req">
								<p className="fo-key">제목</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w375'} value={popTitle} placeholder={''} valueChanged={(value) => setPopTitle(value)}/>
								</div>
							</div>
							<div className="fo-item fo-m-1-3  req">
								<p className="fo-key">게시기간</p>
								<div className="fo-value">
									<div className="hz-root hz-gap5">
										<UIDatePicker className="hz-item" value={stDate} valueChanged={(value) => setStDate(value)}/>
										<span className="hz-item">~</span>
										<UIDatePicker className="hz-item" value={enDate} valueChanged={(value) => setEnDate(value)}/>
									</div>
								</div>
							</div>							
							<div className="fo-item fo-m-1-3  req">
								<p className="fo-key">게시상태</p>
								<div className="fo-value">
									<div className="sl sl-md w375">
										<select name="popStsCd" id="popStsCd" value={popStsCd} className="" onChange={handleSelect}>
											<option value="Y">보임</option>
											<option value="N">숨김</option>
										</select>
									</div>
								</div>
							</div>
							<div className="fo-item  req">
								<p className="fo-key">팝업높이(px)</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w375'} value={popHeight} placeholder={''} valueChanged={(value) => setPopHeight(value)}/>
								</div>
							</div>							
							<div className="fo-item  req">
								<p className="fo-key">팝업너비(px)</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w375'} value={popWidth} placeholder={''} valueChanged={(value) => setPopWidth(value)}/>
								</div>
							</div>							
							<div className="fo-item  req">
								<p className="fo-key">팝업 상단위치(px)</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w375'} value={popTopPos} placeholder={''} valueChanged={(value) => setPopTopPos(value)}/>
								</div>
							</div>							
							<div className="fo-item  req">
								<p className="fo-key">팝업 좌측위치(px)</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w375'} value={popLeftPos} placeholder={''} valueChanged={(value) => setPopLeftPos(value)}/>
								</div>
							</div>							
							<div className="fo-item fo-m-1-3 req">
								<p className="fo-key">이미지 첨부방식</p>
								<div className="fo-value">
									<div className="sl sl-md w375">
										<select name="popSelect" id="popSelect" value={popSelect} className="" onChange={handleSelect}>
											<option value="1">파일</option>
											<option value="2">링크</option>
										</select>
									</div>
								</div>
							</div>
							{ popSelect == '2' ? (
                                <div className="fo-item fo-m-1-3 req">
                                    <p className="fo-key">이미지 URL</p>
                                    <div className="fo-value">
                                        <div className="hz-root hz-gap8">
                                            <UIInput  className={'tf tf-md w375'} value={imgPath} placeholder={''} valueChanged={(value) => setImgPath(value)}/>
                                            <Button color="gray-o" size="md" onClick={() => setModal5312IsOpen(true)}>다운로드</Button>
                                        </div>
                                    </div>
                                </div>
							) : ( <></> ) }
                            <div className="fo-item fo-m-1-3">
                                <p className="fo-key">링크 URL</p>
                                <div className="fo-value">
                                    <UIInput  className={'tf tf-md w100p'} value={linkUrl} placeholder={''} valueChanged={(value) => setLinkUrl(value)}/>
                                </div>
                            </div>
							<div className={ popSelect == '2' ? "fo-item fo-m-1-3" : "fo-item fo-m-1-3 req"}>
								<p className="fo-key">첨부파일</p>
								<div className="fo-value">
									<div className='w100p'>
                                        <Suspense fallback={<PageLoading/>}>
                                            <UI.FileUpload
                                                onCreationComplete={onCreationComplete}
                                                onUploadComplete={onUploadComplete}
                                                attrs={{
                                                    MaxTotalFileCount: "1",
                                                    ExtensionAllowOrLimit: "1",
                                                    ImgPreView: "1",
                                                    Views: "thumbs",
                                                    ExtensionArr: "gif,png,jpg,jpeg"
                                                }}
                                            />
                                        </Suspense>
									</div>											
								</div>
							</div>
						</div> 
					</form>
					<div className="hz-root hz-right hz-gap5">
						<Button color="pri-o" size="sm" onClick={popFormCheck}>저장</Button>
                        <Button color="gray-o" size="sm" onClick={onClickList}>목록</Button>
					</div>					
				</main>
			</div>
            <ModalPopup
                open={modal5312IsOpen}
                title="미리보기"
                size="mid"
                onClose={() => onClose()}
            >
                <div className="modal-con">
                    {/*<LinkPreview url={imgPath} />*/}
                    {/*<img className="w100p" src="https://picsum.photos/536/354" alt="" />*/}
                </div>
                <div className="modal-bottom">
                    <Button color='pri' size="big" onClick={() => onClose()}>확인</Button>
                </div>
            </ModalPopup>
		</PageContainer>
	);
}
export default ContentsContainer;